export default "__VITE_ASSET__BT2Ed0d8__"